import axios from "axios";
import { GURL } from "./global";

export const SendConfirmationCode = (model: any) => {
  const url = `${GURL}/Commiunication/v1/Messages/Send`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};

// export const GetLastCode = (phoneNumber: any) => {
//   const url = `${GURL}/Commiunication/v1/Messages?phoneNumber=${phoneNumber}`;
//   return axios.get(url);
// };

export const GetLastCodeConfirm = (phoneNumber: string, Code: string) => {
  const url = `${GURL}/Commiunication/v1/Messages/GetConfirm?phoneNumber=${phoneNumber}&&Code=${Code}`;
  return axios.get(url);
};

export const SendMail = (model: any) => {
  const url = `${GURL}/Commiunication/v1/Mail/Send`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};
